import { AxiosError } from "axios";
import {
  UserPageResponse,
  UserPageResponseRicevuta,
  UserType,
} from "../../types";
import { BE_BASE_URL, BE_COMPANY_ENDPOINT } from "../../utils/config";
import { Dispatch } from "react";
import { storeUser } from "./userSlice";
import { ThunkDispatch, UnknownAction } from "@reduxjs/toolkit";
import { PersistPartial } from "redux-persist/es/persistReducer";
import { axiosInstance } from "../../provider/authProvider";
import { goToPage } from "../../utils/utils";

export function getCompanyInfoByUser() {
  try {
    const axiosResponse = axiosInstance.get<UserPageResponseRicevuta>(
      BE_BASE_URL + BE_COMPANY_ENDPOINT + "getByUser"
    );
    return axiosResponse.then((response) => response.data);
  } catch (e: unknown) {
    const err = e as AxiosError;
    //console.log("generic error", err);
    goToPage("500");
  }
}

export function setCompanyInfoByUser(newUserData: UserPageResponse) {
  try {
    const axiosResponse = axiosInstance.post<UserPageResponse>(
      BE_BASE_URL + BE_COMPANY_ENDPOINT + "editByUser",
      {
        adminFirstName: newUserData.adminFirstName,
        adminLastName: newUserData.adminLastName,
        adminPhone: newUserData.adminPhone,
        adminEmail: newUserData.adminEmail,
        businessName: newUserData.businessName,
        vatNumber: newUserData.vatNumber,
        cem: newUserData.cem,
        tdEmployees: newUserData.tdEmployees,
        tiEmployees: newUserData.tiEmployees,
        totEmployees: newUserData.totEmployees,
        companyInfo: newUserData.companyInfo,
        headquarters: newUserData.headquarters,
      }
    );
    return axiosResponse.then((response) => response);
  } catch (e: unknown) {
    const err = e as AxiosError;
    if (err.response && err.response.data && err.message) {
      //console.log("error if", err);
    } else {
      //console.log("error else", err);
    }
  }
}

export async function revalidateToken(
  setToken: (newToken: string) => void,
  dispatch: ThunkDispatch<
    { user: UserType; employee: string[] } & PersistPartial,
    undefined,
    UnknownAction
  > &
    Dispatch<UnknownAction>
): Promise<number> {
  let status: number = 401;
  try {
    await axiosInstance
      .get(BE_BASE_URL + "/auth/revalidate")
      .then((response) => {
        dispatch(
          storeUser({
            username: response.data.username,
            email: response.data.email,
            id: response.data.id,
            firstName: response.data.firstName,
            lastName: response.data.lastName,
            role: response.data.role,
            phone: response.data.phone,
            solaLettura: response.data.solaLettura === true,
          })
        );
        setToken(response.data.token);
        status = response.status;
        return status;
      });
    return status;
  } catch (e: unknown) {
    /*
     Lo status vero della risposta, oppure 0 se la risposta non e' arrivata (rete giu',
     timeout, server spento). Prima in quel caso si restituiva 401, e chi chiama buttava via un
     token che poteva essere ancora buono: 401 deve voler dire solo «il server ha detto 401».
    */
    return (e as AxiosError).response?.status ?? 0;
  }
}

